import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, includes } from "lodash";

import { fetchPost } from "../../api/fetch";

import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "../Common/CloseIcon";
import LogDetailsNew from "../SiteEntranceExit/LogDetailsNew/LogDetailsNew";

import { driveInOut, walkInOut, trainInOut } from "../../constants/reducers";
import { eventGroupsData } from "../../constants/eventGroups";
import { LOG_EVENT_GROUP_TYPES } from "../../constants/logEventGroupTypes";

import { fetchCreatedByUsers } from "../../utils/event";

import colors from "../../assets/style/colors";

const styles = {
  dialogRoot: {
    //zIndex: "6000 !important",
  },
  dialogPaper: {
    minWidth: "calc(100vw - 100px)",
    maxWidth: "calc(100vw - 100px)",
    position: "relative",
    height: "calc(100vh - 100px)",
    maxHeight: "850px",
  },
  closeIcon: {
    paddingRight: "12px",
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    top: "12px",
    right: "0px",
    zIndex: 1200,
  },
  link: {
    cursor: "pointer",
    color: colors.primary,
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const LogDetailsDialog = (props) => {
  const {
    classes,
    noLink,
    onClose,
    logId,
    blockLevel2,
    permissions,
    dbPermissions,
  } = props;
  const [log, setLog] = React.useState();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (props.open !== undefined) setOpen(props.open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  React.useEffect(() => {
    if (open) {
      fetchLog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const fetchLog = async () => {
    try {
      let res = await fetchPost("new/event_groups", {
        filter: {
          ids: [logId],
        },
        data: eventGroupsData,
      });
      res.items = await fetchCreatedByUsers(res.items);
      setLog(get(res, ["items", 0]));
    } catch (e) {
      console.log(e);
    }
  };

  const closeFunction = () => {
    setLog();
    setOpen(false);
    if (props.onClose) onClose();
  };

  return (
    <>
      {!noLink && (
        <span className={classes.link} onClick={() => setOpen(true)}>
          {logId}
        </span>
      )}
      <Dialog
        open={open}
        classes={{ root: classes.dialogRoot, paper: classes.dialogPaper }}
      >
        <Box className={classes.closeIcon}>
          <CloseIcon closeFunction={closeFunction} />
        </Box>
        <LogDetailsNew
          section={
            includes(get(LOG_EVENT_GROUP_TYPES, driveInOut), get(log, ["type", "id"])) 
            ? driveInOut 
            : includes(get(LOG_EVENT_GROUP_TYPES, walkInOut), get(log, ["type", "id"])) 
            ? walkInOut
            : includes(get(LOG_EVENT_GROUP_TYPES, trainInOut), get(log, ["type", "id"])) 
            ? trainInOut :
            "unknown"
          }
          log={log}
          refreshLog={() => {
            fetchLog();
            if (props.refresh) {
              props.refresh([logId]);
            }
          }}
          blockLevel2={blockLevel2}
          permissions={permissions}
          dbPermissions={dbPermissions}
          addTempDirectly={props.addTempDirectly}
          closeFunction={closeFunction}
        />
      </Dialog>
    </>
  );
};

export default withStyles(styles)(LogDetailsDialog);
